import { useState } from "react";
import CopyCode from "../../CopyCode/CopyCode";

const CarouselWindow = () => {
  const [idx1, setIdx1] = useState(0);
  const [idx2, setIdx2] = useState(0);

  return (
    <div className="flex flex-col gap-y-10 p-6">
      {/* CAROUSEL WINDOWS */}
      <div className="bg-slate-800 border border-slate-700 rounded-xl p-6 space-y-4">
        <h2 className="text-xl font-bold text-white mb-6">Carousel Windows</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Basic Carousel</label>
            <div className="p-3 bg-slate-950 rounded border border-slate-600">
              <div className="flex items-center gap-2">
                <button onClick={() => setIdx1(Math.max(0, idx1 - 1))} className="px-2 py-1 bg-slate-700 text-slate-300 rounded text-sm">?</button>
                <div className="flex-1 h-24 bg-gradient-to-r from-amber-500 to-blue-500 rounded flex items-center justify-center text-white font-bold">Image {idx1 + 1}</div>
                <button onClick={() => setIdx1(Math.min(2, idx1 + 1))} className="px-2 py-1 bg-slate-700 text-slate-300 rounded text-sm">?</button>
              </div>
              <p className="text-xs text-slate-400 mt-2 text-center">{idx1 + 1} / 3</p>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`const [idx, setIdx] = useState(0);

return (
  <div className="flex items-center gap-2">
    <button onClick={() => setIdx(Math.max(0, idx - 1))}>?</button>
    <img src={images[idx]} className="flex-1 h-40 object-cover" />
    <button onClick={() => setIdx(Math.min(images.length - 1, idx + 1))}>?</button>
  </div>
);`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Dots Navigator</label>
            <div className="p-3 bg-slate-950 rounded border border-slate-600">
              <div className="bg-gradient-to-r from-amber-600 to-amber-600 h-20 rounded mb-3"></div>
              <div className="flex justify-center gap-2">{[0, 1, 2].map(i => <button key={i} onClick={() => setIdx2(i)} className={`w-2 h-2 rounded-full cursor-pointer transition-colors ${i === idx2 ? "bg-amber-400" : "bg-slate-600"}`}></button>)}</div>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="flex justify-center gap-2">
  {images.map((_, i) => (
    <button key={i} onClick={() => setIdx(i)} className={i === idx ? "bg-amber-400 w-3 h-3" : "bg-slate-600 w-2 h-2"} />
  ))}
</div>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Thumbnail Preview</label>
            <div className="p-3 bg-slate-950 rounded border border-slate-600 space-y-2">
              <div className="bg-slate-700 h-16 rounded"></div>
              <div className="flex gap-1">{[1, 2, 3].map(i => <div key={i} className={`w-8 h-8 rounded cursor-pointer ${i === 1 ? "border-2 border-amber-400" : "bg-slate-700"}`}></div>)}</div>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div>
  <img src={images[idx]} className="w-full h-64" />
  <div className="flex gap-2 mt-2">
    {images.map((img, i) => (
      <img key={i} src={img} onClick={() => setIdx(i)} className="w-12 h-12 cursor-pointer" />
    ))}
  </div>
</div>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Auto-play Carousel</label>
            <div className="p-3 bg-slate-950 rounded border border-slate-600">
              <div className="bg-gradient-to-br from-slate-700 to-slate-800 h-20 rounded mb-2 flex items-center justify-center text-slate-500">Auto-playing...</div>
              <div className="flex gap-1">{[1,2,3].map(i => <div key={i} className="flex-1 h-1 bg-slate-700 rounded"></div>)}</div>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`useEffect(() => {
  const timer = setInterval(() => {
    setIdx(prev => (prev + 1) % images.length);
  }, 3000);
  return () => clearInterval(timer);
}, []);`} />
          </div>
        </div>
      </div>

      {/* ADVANCED CAROUSELS */}
      <div className="bg-slate-800 border border-slate-700 rounded-xl p-6 space-y-4">
        <h2 className="text-xl font-bold text-amber-400 mb-6">Advanced Variants</h2>
        <div className="grid grid-cols-1 gap-4">
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Infinite Carousel</label>
            <div className="p-3 bg-slate-950 rounded border border-slate-600 space-y-2">
              <div className="overflow-x-auto flex gap-2 pb-2">
                {[1,2,3,4,5].map(i => <div key={i} className="w-20 h-16 bg-slate-700 rounded flex-shrink-0"></div>)}
              </div>
              <p className="text-xs text-slate-400">Scroll horizontally</p>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="overflow-x-auto flex gap-2">
  {items.map(item => (
    <div key={item} className="w-32 h-20 flex-shrink-0 bg-slate-700 rounded"></div>
  ))}
</div>`} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CarouselWindow;


